import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createServiceCategory = (_, params) => {
  return Api(endPoints.createServiceCategory, params, requestType.POST);
};

const getAllServiceCategory = (name) => {
  return Api(
    `${endPoints.getAllServiceCategory}?name=${name}`,
    null,
    requestType.GET
  );
};

const getServiceCategoryDetail = (id) => {
  return Api(
    `${endPoints.getServiceCategoryDetail}/${id}`,
    null,
    requestType.GET
  );
};

const updateServiceCategory = (id, params) => {
  return Api(
    `${endPoints.updateServiceCategory}/${id}`,
    params,
    requestType.PUT
  );
};

const deleteServiceCategory = (id) => {
  return Api(
    `${endPoints.deleteServiceCategory}/${id}`,
    null,
    requestType.DELETE
  );
};

export {
  createServiceCategory,
  getAllServiceCategory,
  getServiceCategoryDetail,
  updateServiceCategory,
  deleteServiceCategory,
};
